// extracted by mini-css-extract-plugin
export default {"colorBlock":"ColorModule_colorBlock__k2Qyt","buttonsBlock":"ColorModule_buttonsBlock__YHD2M","colorReset":"ColorModule_colorReset__a2r+V","colorSave":"ColorModule_colorSave__rnp0h"};